import classNames from "classnames";
import * as React from "react";

import styles from "./TextInput.module.css";

export type TextInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={classNames(styles.input, className)}
        {...props}
      />
    );
  },
);
